import React from 'react';
import { useLanguage } from '@/context/LanguageContext';
import { LEGAL_LINKS } from './LegalPage';

const TXT = {
  el: { tagline: 'Γραμμή του Ασθενή — Υπηρεσία ενημέρωσης, υποστήριξης και διασύνδεσης με υπηρεσίες υγείας.', legal: 'ΝΟΜΙΚΕΣ ΠΛΗΡΟΦΟΡΙΕΣ' },
  en: { tagline: 'The Patient Line — A service for information, support and connection with healthcare services.', legal: 'LEGAL INFORMATION' },
};

export const LegalFooter = () => {
  const { language } = useLanguage();
  const lang = language === 'el' ? 'el' : 'en';
  const openCookies = () => window.dispatchEvent(new Event('jhouse-open-cookie-policy'));

  return (
    <footer className="bg-[#081222] border-t border-gold/20 py-10 px-[76px] md:px-6 pb-24" data-testid="legal-footer">
      <div className="max-w-5xl mx-auto flex flex-col md:flex-row gap-8 md:justify-between">
        <div className="max-w-md">
          <p className="text-gold font-semibold tracking-wider">J.HOUSE OF SECRETARY</p>
          <p className="text-slate-400 text-sm mt-2 leading-relaxed">{TXT[lang].tagline}</p>
          <p className="text-slate-600 text-xs mt-4">© {new Date().getFullYear()} J.HOUSE OF SECRETARY</p>
        </div>
        <div>
          <p className="text-gold/80 text-xs font-semibold tracking-[0.25em] mb-3">{TXT[lang].legal}</p>
          <ul className="space-y-2">
            {LEGAL_LINKS.map((l) => (
              <li key={l.page}>
                {l.href ? (
                  <a href={l.href} className="text-slate-300 hover:text-gold text-sm transition-colors" data-testid={`footer-legal-${l.page}`}>{l[lang]}</a>
                ) : (
                  <button type="button" onClick={openCookies} className="text-slate-300 hover:text-gold text-sm transition-colors" data-testid={`footer-legal-${l.page}`}>{l[lang]}</button>
                )}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </footer>
  );
};
